/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { readTarget } from "cms/documents/document/helpers";
import { formatBytes } from "utils/format-bytes";

const DocumentStyleSimple = (props) => {
    
    const { document, options } = props || {};
    const targetData = readTarget(options);
    const { target } = targetData || {};

    return (
        <Fragment>
            {document &&
                <a className="document-display-link" href={document.url} target={target}>
                    <div className="document-display">
                        <div className="document-display-text">
                            <div>{document.title}</div>
                        </div>
                        <div className="document-display-size">
                            Size: {formatBytes(document.file_size)}
                        </div>
                    </div>
                </a>
            }
        </Fragment>
    );
};

export { DocumentStyleSimple };
